import { z as e } from "zod";
import { jsx as i } from "react/jsx-runtime";
import { createContext as o, useContext as r } from "react";
import { createEventEmitter as c } from "@made-people/grease-event-emitter";
const v = e.object({
  address: e.custom(),
  shippingAddress: e.custom(),
  validateAddress: e.custom(),
  onUpdate: e.custom()
}), n = o(void 0), E = (t) => /* @__PURE__ */ i(n.Provider, { value: t, children: t.children }), h = () => {
  const t = r(n);
  return t || { additionalData: void 0 };
}, s = o(void 0), C = () => {
  const t = r(s);
  if (!t)
    throw new Error(
      "useCheckoutEventEmitter must be used inside a <CheckoutEventContext />"
    );
  return t;
}, k = c();
export {
  E as CheckoutEventAdditionalDataProvider,
  s as CheckoutEventEmitterContext,
  v as checkoutAddressFormPropsSchema,
  k as checkoutEventEmitter,
  h as useCheckoutEventAdditionalData,
  C as useCheckoutEventEmitter
};
